<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('leads')">
      <button class="btn btn-primary" @click="openModal">Add Lead</button>
    </app-page-top-section>

    <div class="mb-3 d-flex gap-2 flex-wrap">
      <input
        type="text"
        v-model="search"
        @input="fetchLeads"
        placeholder="Search by name or phone"
        class="form-control"
      />

      <select v-model="filterCategory" @change="fetchLeads" class="form-select">
        <option value="">All Categories</option>
        <option v-for="cat in categories" :key="cat.id" :value="cat.id">
          {{ cat.title }}
        </option>
      </select>

      <select v-model="filterProject" @change="fetchLeads" class="form-select">
        <option value="">All Projects</option>
        <option v-for="project in projects" :key="project.id" :value="project.id">
          {{ project.title }}
        </option>
      </select>
    </div>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Phone</th>
        <th>Address</th>
        <th>Project</th>
        <th>Category</th>
        <th>Details</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(lead,index) in leads.data" :key="lead.id">
        <td>{{ (leads.current_page - 1) * 10 + index + 1 }}</td>
        <td>{{ lead.name }}</td>
        <td>{{ lead.phone || '-' }}</td>
        <td>{{ lead.address || '-' }}</td>
        <td>{{ lead.project ? lead.project.title : '-' }}</td>
        <td>{{ lead.category ? lead.category.title : '-' }}</td>
        <td>{{ lead.details || '-' }}</td>
        <td>
          <button class="btn btn-sm btn-primary" @click="editLead(lead)">Edit</button>
          <button class="btn btn-sm btn-danger" @click="deleteLead(lead.id)">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>

    <nav v-if="leads.last_page > 1">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: leads.current_page === 1 }" @click="changePage(leads.current_page - 1)">
          <a class="page-link" href="#">Previous</a>
        </li>
        <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: leads.current_page === page }" @click="changePage(page)">
          <a class="page-link" href="#">{{ page }}</a>
        </li>
        <li class="page-item" :class="{ disabled: leads.current_page === leads.last_page }" @click="changePage(leads.current_page + 1)">
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>

    <lead-form-modal
      v-if="isModalActive"
      v-model="isModalActive"
      :lead="selectedLead"
      :projects="projects"
      :categories="categories"
      @saved="fetchLeads"
    />
  </div>
</template>

<script>
import LeadFormModal from './Components/LeadFormModal.vue'

export default {
  name: 'AppLeads',
  components: { LeadFormModal },
  data() {
    return {
      leads: { data: [], current_page: 1, last_page: 1 },
      projects: [],
      categories: [],
      isModalActive: false,
      selectedLead: null,
      search: '',
      filterProject: '',
      filterCategory: ''
    }
  },
  mounted() {
    this.fetchProjects()
    this.fetchCategories()
    this.fetchLeads()
  },
  computed: {
    totalPages() {
      const pages = []
      for (let i = 1; i <= this.leads.last_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    fetchProjects() {
      axios.get('/leads/projects').then(res => { this.projects = res.data })
    },
    fetchCategories() {
      axios.get('/leads/categories').then(res => { this.categories = res.data })
    },
    fetchLeads(page = 1) {
      axios.get('/leads', {
        params: {
          search: this.search,
          target_project_id: this.filterProject,
          leads_category_id: this.filterCategory,
          per_page: 10,
          page: page
        }
      }).then(res => { this.leads = res.data })
    },
    changePage(page) {
      if (page < 1 || page > this.leads.last_page) return
      this.fetchLeads(page)
    },
    openModal() {
      this.selectedLead = null
      this.isModalActive = true
    },
    editLead(lead) {
      this.selectedLead = lead
      this.isModalActive = true
    },
    deleteLead(id) {
      if (confirm('Are you sure?')) {
        axios.delete(`/leads/${id}`).then(() => {
          this.fetchLeads(this.leads.current_page)
          alert('Deleted successfully!')
        })
      }
    }
  }
}
</script>

<style>
.pagination .page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}
.pagination .page-item.active .page-link {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}
</style>


